import { render, staticRenderFns } from "./marketingMaterials.vue?vue&type=template&id=5f648eee&scoped=true&"
import script from "./marketingMaterials.vue?vue&type=script&lang=js&"
export * from "./marketingMaterials.vue?vue&type=script&lang=js&"
import style0 from "./marketingMaterials.vue?vue&type=style&index=0&id=5f648eee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f648eee",
  null
  
)

export default component.exports